import { useState} from "react";

// ─── Reference tables ────────────────────────────────────────────────────────

const VESSEL_DEFAULTS = {
  mini:        { dwt: 8000,   intake: 7500,   spdL:11.0, spdB:11.5, focL: 9,  focB: 8,  focAuxSea:0.6, focAuxPort:1.2, opex:3500,  tc:7000,  label:"Mini-Bulker" },
  handysize:   { dwt: 32000,  intake: 30000,  spdL:12.0, spdB:12.5, focL:18,  focB:16,  focAuxSea:1.0, focAuxPort:2.0, opex:5500,  tc:11000, label:"Handysize" },
  supramax:    { dwt: 58000,  intake: 55000,  spdL:13.5, spdB:14.0, focL:24,  focB:22,  focAuxSea:1.3, focAuxPort:2.5, opex:6000,  tc:13500, label:"Supramax" },
  ultramax:    { dwt: 63000,  intake: 60000,  spdL:14.0, spdB:14.5, focL:26,  focB:24,  focAuxSea:1.4, focAuxPort:2.8, opex:6200,  tc:14500, label:"Ultramax" },
  panamax:     { dwt: 76000,  intake: 73000,  spdL:14.0, spdB:14.5, focL:32,  focB:28,  focAuxSea:1.5, focAuxPort:3.0, opex:6500,  tc:15500, label:"Panamax" },
  kamsarmax:   { dwt: 82000,  intake: 80000,  spdL:14.0, spdB:14.5, focL:30,  focB:28,  focAuxSea:1.5, focAuxPort:3.0, opex:6700,  tc:16000, label:"Kamsarmax" },
  postpanamax: { dwt: 95000,  intake: 92000,  spdL:14.0, spdB:14.5, focL:34,  focB:30,  focAuxSea:1.6, focAuxPort:3.2, opex:7000,  tc:17500, label:"Post-Panamax" },
  capesize:    { dwt: 180000, intake: 175000, spdL:14.0, spdB:14.5, focL:42,  focB:38,  focAuxSea:1.8, focAuxPort:3.5, opex:7500,  tc:25000, label:"Capesize" },
  newcastlemax:{ dwt: 210000, intake: 205000, spdL:14.0, spdB:14.5, focL:50,  focB:45,  focAuxSea:2.0, focAuxPort:4.0, opex:8000,  tc:28000, label:"Newcastlemax" },
  vloc:        { dwt: 320000, intake: 315000, spdL:14.0, spdB:14.5, focL:70,  focB:65,  focAuxSea:2.5, focAuxPort:5.0, opex:9000,  tc:35000, label:"VLOC / Valemax" },
};

const CARGO_SF = {
  iron_ore_fines:0.40, iron_ore_lump:0.45, coal_steam:1.25, coal_coking:1.15,
  bauxite:0.85, grain_wheat:1.30, grain_corn:1.35, soybean:1.40,
  petcoke:1.10, cement:0.80, fertilizer:1.30, sugar:1.20, steel:0.45, other:1.00,
};

const CANAL_COSTS = { none:0, suez:300000, panama:200000, both:500000 };

const FUEL_TTW = {
  vlsfo:           { co2:3.114, lcv:41.0, ch4c:0.00005, n2o:0.00018 },
  lsmgo:           { co2:3.206, lcv:42.7, ch4c:0.00005, n2o:0.00018 },
  hsfo:            { co2:3.114, lcv:40.5, ch4c:0.00005, n2o:0.00018 },
  lng:             { co2:2.750, lcv:49.0, ch4c:0.00000, n2o:0.00011 },
  methanol_fossil: { co2:1.375, lcv:19.9, ch4c:0.00003, n2o:0.00002 },
  methanol_bio:    { co2:1.375, lcv:19.9, ch4c:0.00003, n2o:0.00002 },
  methanol_e:      { co2:1.375, lcv:19.9, ch4c:0.00003, n2o:0.00002 },
  ammonia_blue:    { co2:0.000, lcv:18.6, ch4c:0.00000, n2o:0.00020 },
  ammonia_green:   { co2:0.000, lcv:18.6, ch4c:0.00000, n2o:0.00020 },
  b30:             { co2:3.114*0.7, lcv:40.5, ch4c:0.00005, n2o:0.00018 },
  biofuel_blend:   { co2:3.114, lcv:41.0, ch4c:0.00005, n2o:0.00018 },
};

const GWP_CH4 = 28;
const GWP_N2O = 265;

const ENGINE_SLIP = {
  ice_2s:0, ice_4s:0, df_lng_hp2s:0.002, df_lng_lp2s:0.017, df_lng_lp4s:0.031,
  df_methanol:0, df_ammonia:0, df_lng_aux:0.035, df_methanol_aux:0, df_ammonia_aux:0,
};

const WTW_INTENSITY = {
  ice_2s_vlsfo:91.5, ice_2s_lsmgo:93.3, ice_2s_hsfo:91.5, ice_2s_b30:72.0,
  ice_4s_vlsfo:91.5, ice_4s_lsmgo:93.3, ice_4s_hsfo:91.5, ice_4s_b30:72.0,
  ice_2s_lng:72.0, ice_4s_lng:73.0,
  df_lng_hp2s_lng:76.0, df_lng_lp2s_lng:86.0, df_lng_lp4s_lng:98.0,
  df_methanol_methanol_fossil:104.0, df_methanol_methanol_bio:27.0, df_methanol_methanol_e:7.0, df_methanol_lsmgo:93.3,
  df_ammonia_ammonia_blue:45.0, df_ammonia_ammonia_green:5.0, df_ammonia_lsmgo:93.3,
  ice_4s_aux_vlsfo:91.5, ice_4s_aux_lsmgo:93.3, ice_4s_aux_hsfo:91.5,
  df_lng_aux_lng:99.0, df_lng_aux_lsmgo:93.3, df_lng_aux_vlsfo:91.5,
  df_methanol_aux_methanol_fossil:104.0, df_methanol_aux_methanol_bio:27.0, df_methanol_aux_lsmgo:93.3,
  df_ammonia_aux_ammonia_blue:45.0, df_ammonia_aux_ammonia_green:5.0, df_ammonia_aux_lsmgo:93.3,
};

const FUELEU_TARGETS = {
  2024:null, 2025:89.34, 2026:89.34, 2027:89.34, 2028:89.34, 2029:89.34,
  2030:85.69, 2031:85.69, 2032:85.69, 2033:85.69, 2034:85.69,
  2035:77.94, 2040:62.90, 2045:34.64, 2050:18.23,
};

const ETS_PHASE_IN = {
  2024:{ factor:0.40, gases:"co2" },
  2025:{ factor:0.70, gases:"co2" },
  2026:{ factor:1.00, gases:"all" },
};

const HAS_PILOT = ["df_lng_hp2s","df_lng_lp2s","df_lng_lp4s","df_methanol","df_ammonia"];
const BIO_FUELS = ["biofuel_blend"];

// ─── Helpers ─────────────────────────────────────────────────────────────────

const fmt = (n, dec=0) => n == null || isNaN(n) ? "—" :
  n.toLocaleString("en-US", { minimumFractionDigits:dec, maximumFractionDigits:dec });
const fmtMoney = (n) => n == null || isNaN(n) ? "—" : "$" + Math.round(n).toLocaleString("en-US");
const fmtMoneyDec = (n) => n == null || isNaN(n) ? "—" :
  "$" + n.toLocaleString("en-US", { minimumFractionDigits:2, maximumFractionDigits:2 });
const fmtMoneyShort = (n) => {
  if (n == null || isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e6) return (n>=0?"":"-") + "$" + (abs/1e6).toFixed(2) + "M";
  if (abs >= 1e3) return (n>=0?"":"-") + "$" + (abs/1e3).toFixed(1) + "k";
  return (n>=0?"":"-") + "$" + abs.toFixed(0);
};

function getWtwIntensity(engine, fuel, bioPct, bioWtT) {
  if (fuel === "biofuel_blend") {
    const bio = Math.max(0, Math.min(1, bioPct || 0));
    const wt = (bioWtT != null) ? bioWtT : 15;
    return bio * wt + (1 - bio) * 91.5;
  }
  const key = `${engine}_${fuel}`;
  if (WTW_INTENSITY[key] != null) return WTW_INTENSITY[key];
  if (engine.startsWith("ice")) {
    if (fuel === "vlsfo" || fuel === "hsfo") return 91.5;
    if (fuel === "lsmgo") return 93.3;
    if (fuel === "b30") return 72.0;
  }
  return 91.5;
}

function calcVessel(v, shared, market) {
  const { ladenDist, ballastDist, wx, portDaysLoad, portDaysDisch, canal,
          charterType, exposure, ukExposure, cargoMode, cargoQty, sf } = shared;
  const { px, portCostLoad, portCostDisch, canalCost, commissionPct,
          euaPrice, eurUsd, ukaPrice, gbpUsd, fuelEuPenaltyEur, fuelEuTarget,
          calcYear, repeatYears, bioWtT } = market;

  const canalDays = (canal === "none" ? 0 : (canal === "both" ? 2 : 1));
  const scopeETS = exposure === "full" ? 1.0 : (exposure === "half" ? 0.5 : 0);
  const scopeFuelEU = scopeETS;
  const scopeUK = ukExposure === "domestic" ? 1.0 : (ukExposure === "gbni" ? 0.5 : (ukExposure === "intl" ? 0.5 : 0));

  const { intake, spdLaden, spdBall, focLaden, focBall, focAuxSea, focAuxPort,
          engine, fuel, auxEngine, auxFuel, pilot, bio, opex, tcRate, freightRate, dwt } = v;

  const pilotPct = HAS_PILOT.includes(engine) ? (pilot / 100) : 0;
  const bioPct = BIO_FUELS.includes(fuel) ? (bio / 100) : 0;

  const holdVolM3 = dwt * 1.25;
  const volumeLimit = Math.floor(holdVolM3 / Math.max(0.2, sf));
  let cargo = Math.min(intake, volumeLimit);
  if (cargoMode === "fixed") cargo = Math.min(cargo, cargoQty);
  cargo = Math.max(0, cargo);

  const spdL = Math.max(1, spdLaden);
  const spdB = Math.max(1, spdBall);
  const ladenDays = (ladenDist * (1 + wx)) / (spdL * 24);
  const ballastDays = (ballastDist * (1 + wx)) / (spdB * 24);
  const seaDays = ladenDays + ballastDays;
  const portDays = portDaysLoad + portDaysDisch;
  const voyageDays = seaDays + portDays + canalDays;

  let mainFuelGross = focLaden * ladenDays + focBall * ballastDays;
  if (canalDays > 0) mainFuelGross += ((focLaden + focBall) / 2) * canalDays;

  let mainFuelInfo = FUEL_TTW[fuel] || FUEL_TTW.vlsfo;
  if (fuel === "biofuel_blend") {
    mainFuelInfo = {
      co2: (1 - bioPct) * FUEL_TTW.vlsfo.co2 + bioPct * 0.0,
      lcv: FUEL_TTW.vlsfo.lcv, ch4c: FUEL_TTW.vlsfo.ch4c, n2o: FUEL_TTW.vlsfo.n2o,
    };
  }
  const pilotInfo = FUEL_TTW.lsmgo;
  const mainFuelMass_t = mainFuelGross * (1 - pilotPct);
  const mainEnergy_MJ = mainFuelMass_t * 1000 * mainFuelInfo.lcv;
  const pilotEnergy_MJ = (pilotPct > 0 && mainFuelGross > 0)
    ? pilotPct * (mainFuelGross * 1000 * mainFuelInfo.lcv) : 0;
  const pilotFuelMass_t = pilotEnergy_MJ / (pilotInfo.lcv * 1000);

  const mainSlipFrac = (fuel === "lng") ? (ENGINE_SLIP[engine] || 0) : 0;
  const mainCO2_g = mainFuelMass_t * 1e6 * mainFuelInfo.co2;
  const mainCH4slip = mainFuelMass_t * 1e6 * mainSlipFrac;
  const mainCH4comb = mainFuelMass_t * 1e6 * (mainFuelInfo.ch4c || 0);
  const mainCH4_g = mainCH4slip + mainCH4comb;
  const mainN2O_g = mainFuelMass_t * 1e6 * (mainFuelInfo.n2o || 0);
  const pilotCO2_g = pilotFuelMass_t * 1e6 * pilotInfo.co2;
  const pilotCH4_g = pilotFuelMass_t * 1e6 * (pilotInfo.ch4c || 0);
  const pilotN2O_g = pilotFuelMass_t * 1e6 * (pilotInfo.n2o || 0);
  const mainCO2eq_g = mainCO2_g + pilotCO2_g + (mainCH4_g + pilotCH4_g) * GWP_CH4 + (mainN2O_g + pilotN2O_g) * GWP_N2O;

  const auxFuelSea_t = focAuxSea * (seaDays + canalDays);
  const auxFuelPort_t = focAuxPort * portDays;
  const auxFuelMass_t = auxFuelSea_t + auxFuelPort_t;
  const auxFuelInfo = FUEL_TTW[auxFuel] || FUEL_TTW.lsmgo;
  const auxEnergySea_MJ = auxFuelSea_t * 1000 * auxFuelInfo.lcv;
  const auxEnergyPort_MJ = auxFuelPort_t * 1000 * auxFuelInfo.lcv;
  const auxSlipFrac = (auxFuel === "lng") ? (ENGINE_SLIP[auxEngine] || 0) : 0;
  const auxCO2_g = auxFuelMass_t * 1e6 * auxFuelInfo.co2;
  const auxCH4_g = auxFuelMass_t * 1e6 * (auxSlipFrac + (auxFuelInfo.ch4c || 0));
  const auxN2O_g = auxFuelMass_t * 1e6 * (auxFuelInfo.n2o || 0);
  const auxCO2eq_g = auxCO2_g + auxCH4_g * GWP_CH4 + auxN2O_g * GWP_N2O;

  let mainFuelPrice;
  if (fuel === "biofuel_blend") {
    const pxBio = px.biofuel || 1100;
    mainFuelPrice = bioPct * pxBio + (1 - bioPct) * (px.vlsfo || 0);
  } else {
    mainFuelPrice = px[fuel] || 0;
  }
  const pilotFuelPrice = px.lsmgo || 0;
  const auxFuelPrice = px[auxFuel] || 0;
  const bunkerCost =
      mainFuelMass_t  * mainFuelPrice
    + pilotFuelMass_t * pilotFuelPrice
    + auxFuelMass_t   * auxFuelPrice;

  const totalCO2_g = mainCO2_g + pilotCO2_g + auxCO2_g;
  const totalCH4_g = mainCH4_g + pilotCH4_g + auxCH4_g;
  const totalN2O_g = mainN2O_g + pilotN2O_g + auxN2O_g;
  const totalCO2eq_g = mainCO2eq_g + auxCO2eq_g;
  const totalCO2_t = totalCO2_g / 1e6;
  const totalCO2eq_t = totalCO2eq_g / 1e6;

  const wtwMain = getWtwIntensity(engine, fuel, bioPct, bioWtT);
  const wtwPilot = 93.3;
  const wtwAux = getWtwIntensity(auxEngine, auxFuel, 0, bioWtT);
  const totalEnergy_MJ = mainEnergy_MJ + pilotEnergy_MJ + auxEnergySea_MJ + auxEnergyPort_MJ;
  const wtwIntensity = totalEnergy_MJ > 0
    ? (mainEnergy_MJ * wtwMain + pilotEnergy_MJ * wtwPilot + (auxEnergySea_MJ + auxEnergyPort_MJ) * wtwAux) / totalEnergy_MJ
    : 0;

  const yr = parseInt(calcYear);
  let phaseInfo = ETS_PHASE_IN[yr];
  if (!phaseInfo) phaseInfo = { factor:1.0, gases:"all" };
  const etsFactor = phaseInfo.factor;
  const etsAllGases = phaseInfo.gases === "all";
  const fuelEuActive = yr >= 2025;
  const repeatMult = Math.min(1.5, 1.0 + parseInt(repeatYears) * 0.1);

  const etsBasis_t = etsAllGases ? totalCO2eq_t : totalCO2_t;
  const etsCostEur = etsBasis_t * euaPrice * scopeETS * etsFactor;
  const etsCostUsd = etsCostEur * eurUsd;

  let ukActive = yr >= 2026;
  let effScopeUK = scopeUK;
  if (ukExposure === "intl" && yr < 2028) effScopeUK = 0;
  const ukEtsCostGbp = ukActive ? (totalCO2eq_t * ukaPrice * effScopeUK) : 0;
  const ukEtsCostUsd = ukEtsCostGbp * gbpUsd;

  let fuelEuPenaltyEurTot = 0;
  if (fuelEuActive && fuelEuTarget > 0) {
    const deficit_gCO2e = (wtwIntensity - fuelEuTarget) * totalEnergy_MJ;
    const deficit_scoped = deficit_gCO2e * scopeFuelEU;
    if (deficit_scoped > 0) {
      const deficit_tVLSFOe = deficit_scoped / (fuelEuTarget * 41000);
      fuelEuPenaltyEurTot = deficit_tVLSFOe * fuelEuPenaltyEur * repeatMult;
    }
  }
  const fuelEuPenaltyUsd = fuelEuPenaltyEurTot * eurUsd;

  const portTotal = portCostLoad + portCostDisch + canalCost;
  let grossFreight = charterType === "voyage" ? cargo * freightRate : tcRate * voyageDays;
  const commissionUsd = grossFreight * commissionPct;
  const opexTotal = opex * voyageDays;
  const voyageCosts = bunkerCost + portTotal + etsCostUsd + ukEtsCostUsd + fuelEuPenaltyUsd + commissionUsd;
  const tce = voyageDays > 0 ? (grossFreight - voyageCosts) / voyageDays : 0;
  const pnl = grossFreight - voyageCosts - opexTotal;
  const costPerTon = cargo > 0 ? (voyageCosts + opexTotal) / cargo : 0;

  return {
    voyageDays, seaDays, portDays, ladenDays, ballastDays, canalDays,
    cargo, grossFreight,
    bunkerCost, portTotal, etsCostUsd, ukEtsCostUsd, fuelEuPenaltyUsd, commissionUsd, opexTotal,
    voyageCosts, tce, pnl, costPerTon,
    totalCO2_t, totalCO2eq_t, totalCH4_g, totalN2O_g, wtwIntensity,
    mainFuelMass_t, pilotFuelMass_t, auxFuelMass_t,
    engine, fuel, auxEngine, auxFuel,
    mainSlipFrac, auxSlipFrac,
  };
}

// ─── Sub-components ───────────────────────────────────────────────────────────

function SegmentedToggle({ options, value, onChange }) {
  return (
    <div className="bcc-segmented">
      {options.map(opt => (
        <button
          key={opt.value}
          type="button"
          className={value === opt.value ? "active" : ""}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

function Field({ label, hint, children }) {
  return (
    <div className="bcc-field">
      <label className="bcc-label">{label}{hint && <span className="bcc-hint"> {hint}</span>}</label>
      {children}
    </div>
  );
}

function NumInput({ value, onChange, min, max, step, unit }) {
  return (
    <div className="bcc-input-wrap">
      <input
        type="number"
        className="bcc-input"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={e => onChange(parseFloat(e.target.value) || 0)}
      />
      {unit && <span className="bcc-unit">{unit}</span>}
    </div>
  );
}

function SelectInput({ value, onChange, options }) {
  return (
    <select className="bcc-select" value={value} onChange={e => onChange(e.target.value)}>
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}

function Subgroup({ title, children }) {
  return (
    <div className="bcc-subgroup">
      <div className="bcc-subgroup-title">{title}</div>
      {children}
    </div>
  );
}

function VesselCard({ id, vessel, onChange, charterType }) {
  const isA = id === "A";
  const def = VESSEL_DEFAULTS[vessel.sizeClass];

  function handleClassChange(val) {
    const d = VESSEL_DEFAULTS[val];
    onChange({ ...vessel, sizeClass: val, dwt: d.dwt, intake: d.intake, spdLaden: d.spdL, spdBall: d.spdB,
      focLaden: d.focL, focBall: d.focB, focAuxSea: d.focAuxSea, focAuxPort: d.focAuxPort, opex: d.opex, tcRate: d.tc });
  }

  function handleEngineChange(val) {
    let fuel = vessel.fuel;
    if (val.startsWith("df_lng")) fuel = "lng";
    else if (val === "df_methanol") fuel = "methanol_fossil";
    else if (val === "df_ammonia") fuel = "ammonia_blue";
    else if (val.startsWith("ice")) fuel = "vlsfo";
    onChange({ ...vessel, engine: val, fuel });
  }

  function handleAuxEngineChange(val) {
    let auxFuel = "lsmgo";
    if (val === "df_lng_aux") auxFuel = "lng";
    else if (val === "df_methanol_aux") auxFuel = "methanol_fossil";
    else if (val === "df_ammonia_aux") auxFuel = "ammonia_blue";
    onChange({ ...vessel, auxEngine: val, auxFuel });
  }

  const showPilot = HAS_PILOT.includes(vessel.engine);
  const showBio = BIO_FUELS.includes(vessel.fuel);

  return (
    <div className={`bcc-vessel-card ${isA ? "vessel-a" : "vessel-b"}`}>
      <div className={`bcc-vessel-banner ${isA ? "banner-a" : "banner-b"}`}>
        <div className="bcc-vessel-chip">
          <span className={`bcc-dot ${isA ? "dot-a" : "dot-b"}`}></span>
          Vessel {id}
        </div>
        <span className="bcc-vessel-hint">{def.label}</span>
      </div>

      <div className="bcc-field-grid">
        <Field label="Vessel name" hint="(your tag)">
          <input className="bcc-input" type="text" value={vessel.name}
            onChange={e => onChange({ ...vessel, name: e.target.value })} placeholder={`e.g. MV ${isA ? "Atlantic Cape" : "Pacific Kamsar"}`} />
        </Field>
        <Field label="Size class">
          <SelectInput value={vessel.sizeClass} onChange={handleClassChange} options={[
            {value:"mini",label:"Mini-Bulker (3–10k DWT)"},{value:"handysize",label:"Handysize (10–40k)"},
            {value:"supramax",label:"Supramax (50–60k)"},{value:"ultramax",label:"Ultramax (60–65k)"},
            {value:"panamax",label:"Panamax (65–80k)"},{value:"kamsarmax",label:"Kamsarmax (~82k)"},
            {value:"postpanamax",label:"Post-Panamax (85–100k)"},{value:"capesize",label:"Capesize (100–200k)"},
            {value:"newcastlemax",label:"Newcastlemax (~210k)"},{value:"vloc",label:"VLOC / Valemax (300–400k)"},
          ]} />
        </Field>
        <Field label="Deadweight (DWT)">
          <NumInput value={vessel.dwt} onChange={v => onChange({...vessel, dwt:v})} min={3000} step={1000} unit="t" />
        </Field>
        <Field label="Cargo capacity">
          <NumInput value={vessel.intake} onChange={v => onChange({...vessel, intake:v})} min={0} step={500} unit="t" />
        </Field>
      </div>

      <Subgroup title="Speed & main-engine consumption">
        <div className="bcc-field-grid">
          <Field label="Speed · laden"><NumInput value={vessel.spdLaden} onChange={v => onChange({...vessel, spdLaden:v})} min={6} max={20} step={0.1} unit="kn" /></Field>
          <Field label="Speed · ballast"><NumInput value={vessel.spdBall} onChange={v => onChange({...vessel, spdBall:v})} min={6} max={20} step={0.1} unit="kn" /></Field>
          <Field label="Main FOC · laden"><NumInput value={vessel.focLaden} onChange={v => onChange({...vessel, focLaden:v})} min={0} step={0.5} unit="t/d" /></Field>
          <Field label="Main FOC · ballast"><NumInput value={vessel.focBall} onChange={v => onChange({...vessel, focBall:v})} min={0} step={0.5} unit="t/d" /></Field>
        </div>
      </Subgroup>

      <Subgroup title="Main engine">
        <div className="bcc-field-grid">
          <Field label="Engine type">
            <SelectInput value={vessel.engine} onChange={handleEngineChange} options={[
              {value:"ice_2s",label:"ICE · 2-stroke diesel (no methane slip)"},
              {value:"ice_4s",label:"ICE · 4-stroke diesel (no methane slip)"},
              {value:"df_lng_hp2s",label:"Dual-fuel LNG · HP 2-stroke (~0.2% slip)"},
              {value:"df_lng_lp2s",label:"Dual-fuel LNG · LP 2-stroke (~1.7% slip)"},
              {value:"df_lng_lp4s",label:"Dual-fuel LNG · LP 4-stroke (~3.1% slip)"},
              {value:"df_methanol",label:"Dual-fuel Methanol · 2-stroke"},
              {value:"df_ammonia",label:"Dual-fuel Ammonia · 2-stroke"},
            ]} />
          </Field>
          <Field label="Main fuel at sea">
            <SelectInput value={vessel.fuel} onChange={v => onChange({...vessel, fuel:v})} options={[
              {value:"vlsfo",label:"VLSFO (0.5%S)"},{value:"lsmgo",label:"LSMGO (0.1%S)"},
              {value:"hsfo",label:"HSFO + scrubber"},{value:"lng",label:"LNG"},
              {value:"methanol_fossil",label:"Methanol (fossil/grey)"},{value:"methanol_bio",label:"Methanol (bio)"},
              {value:"methanol_e",label:"e-Methanol"},{value:"ammonia_blue",label:"Ammonia (blue)"},
              {value:"ammonia_green",label:"Ammonia (green)"},{value:"b30",label:"B30 biofuel blend"},
              {value:"biofuel_blend",label:"Biofuel blend (custom %)"},
            ]} />
          </Field>
          {showPilot && (
            <Field label="Pilot fuel" hint="(% of energy)">
              <NumInput value={vessel.pilot} onChange={v => onChange({...vessel, pilot:v})} min={0} max={15} step={0.5} unit="%" />
            </Field>
          )}
          {showBio && (
            <Field label="Bio content" hint="(in main fuel)">
              <NumInput value={vessel.bio} onChange={v => onChange({...vessel, bio:v})} min={0} max={100} step={1} unit="%" />
            </Field>
          )}
        </div>
      </Subgroup>

      <Subgroup title="Auxiliary engines (gensets)">
        <div className="bcc-field-grid">
          <Field label="Aux FOC · at sea"><NumInput value={vessel.focAuxSea} onChange={v => onChange({...vessel, focAuxSea:v})} min={0} step={0.1} unit="t/d" /></Field>
          <Field label="Aux FOC · in port"><NumInput value={vessel.focAuxPort} onChange={v => onChange({...vessel, focAuxPort:v})} min={0} step={0.1} unit="t/d" /></Field>
          <Field label="Aux engine type">
            <SelectInput value={vessel.auxEngine} onChange={handleAuxEngineChange} options={[
              {value:"ice_4s",label:"ICE · 4-stroke (no slip)"},
              {value:"df_lng_aux",label:"DF-LNG · 4-stroke aux (~3.5% slip)"},
              {value:"df_methanol_aux",label:"DF-Methanol · 4-stroke aux"},
              {value:"df_ammonia_aux",label:"DF-Ammonia · 4-stroke aux"},
            ]} />
          </Field>
          <Field label="Aux fuel">
            <SelectInput value={vessel.auxFuel} onChange={v => onChange({...vessel, auxFuel:v})} options={[
              {value:"lsmgo",label:"LSMGO (0.1%S)"},{value:"vlsfo",label:"VLSFO"},
              {value:"hsfo",label:"HSFO + scrubber"},{value:"lng",label:"LNG"},
              {value:"methanol_fossil",label:"Methanol (fossil)"},{value:"methanol_bio",label:"Methanol (bio)"},
              {value:"ammonia_blue",label:"Ammonia (blue)"},{value:"ammonia_green",label:"Ammonia (green)"},
            ]} />
          </Field>
        </div>
        <p className="bcc-note">Aux engines run continuously (sea + canal + port). On LNG ships, aux often stays on MGO for safety/redundancy.</p>
      </Subgroup>

      <Subgroup title="Commercial">
        <div className="bcc-field-grid">
          <Field label="Daily OPEX" hint="(crew, insurance, repairs)">
            <NumInput value={vessel.opex} onChange={v => onChange({...vessel, opex:v})} min={0} step={100} unit="$/d" />
          </Field>
          {charterType === "tc" && (
            <Field label="TC hire rate">
              <NumInput value={vessel.tcRate} onChange={v => onChange({...vessel, tcRate:v})} min={0} step={500} unit="$/d" />
            </Field>
          )}
          {charterType === "voyage" && (
            <Field label="Freight rate">
              <NumInput value={vessel.freightRate} onChange={v => onChange({...vessel, freightRate:v})} min={0} step={0.25} unit="$/t" />
            </Field>
          )}
        </div>
      </Subgroup>
    </div>
  );
}

function ResultCard({ id, result, isWinner, vessel, market }) {
  const isA = id === "A";
  const def = VESSEL_DEFAULTS[vessel.sizeClass];
  const name = vessel.name || `Vessel ${id}`;
  const tceNeg = result.tce < 0;

  return (
    <div className={`bcc-result-vessel ${isA ? "result-a" : "result-b"} ${isWinner ? "result-winner" : ""}`}>
      <div className="bcc-result-head">
        <div className="bcc-result-title">
          {name}
          <small>{def.label} · {fmt(vessel.dwt)} DWT</small>
        </div>
        {isWinner && <span className="bcc-winner-badge">★ Winner</span>}
      </div>

      <div className="bcc-headline-num">
        <div className="bcc-hn-label">TCE · Time Charter Equivalent</div>
        <div>
          <span className={`bcc-hn-value ${tceNeg ? "neg" : ""}`}>{fmtMoney(result.tce)}</span>
          <span className="bcc-hn-unit">$/day</span>
        </div>
      </div>

      <StatGroup title="Voyage">
        <StatRow label="Total voyage days" value={fmt(result.voyageDays, 1) + " d"} />
        <StatRow label="Cargo lifted" value={fmt(result.cargo) + " t"} />
        <StatRow label="Gross freight" value={fmtMoney(result.grossFreight)} />
      </StatGroup>

      <StatGroup title="Costs">
        <StatRow label="Bunker cost" value={fmtMoney(result.bunkerCost)} />
        <StatRow label="Port + canal" value={fmtMoney(result.portTotal)} />
        <StatRow label="EU ETS" value={fmtMoney(result.etsCostUsd)} />
        <StatRow label="UK ETS" value={fmtMoney(result.ukEtsCostUsd)} />
        <StatRow label="FuelEU penalty" value={fmtMoney(result.fuelEuPenaltyUsd)} bad={result.fuelEuPenaltyUsd > 0} />
        <StatRow label="OPEX (voyage)" value={fmtMoney(result.opexTotal)} />
        <StatRow label="Commission" value={fmtMoney(result.commissionUsd)} />
      </StatGroup>

      <StatGroup title="Emissions">
        <StatRow label="Total CO₂ (TtW)" value={fmt(result.totalCO2_t, 0) + " t"} />
        <StatRow label="Total CO₂eq (TtW, incl. CH₄)" value={fmt(result.totalCO2eq_t, 0) + " t"} />
        <StatRow label="WtW GHG intensity"
          value={fmt(result.wtwIntensity, 1) + " gCO₂e/MJ"}
          bad={result.wtwIntensity > market.fuelEuTarget}
          good={result.wtwIntensity <= market.fuelEuTarget} />
        <StatRow label="CH₄ & N₂O"
          value={fmt(result.totalCH4_g / 1e6, 2) + " t CH₄ · " + fmt(result.totalN2O_g / 1e6, 2) + " t N₂O"} />
      </StatGroup>

      <StatGroup title="Bottom line">
        <StatRow label="Cost per ton delivered" value={fmtMoneyDec(result.costPerTon)} />
        <StatRow label="Voyage P&L" value={fmtMoney(result.pnl)} bad={result.pnl < 0} good={result.pnl >= 0} />
      </StatGroup>
    </div>
  );
}

function StatGroup({ title, children }) {
  return (
    <div className="bcc-stat-group">
      <div className="bcc-stat-group-title">{title}</div>
      <div className="bcc-stat-rows">{children}</div>
    </div>
  );
}

function StatRow({ label, value, bad, good }) {
  return (
    <div className="bcc-stat-row">
      <span className="bcc-stat-label">{label}</span>
      <span className={`bcc-stat-value ${bad ? "bad" : ""} ${good ? "good" : ""}`}>{value}</span>
    </div>
  );
}

function CompareTable({ rA, rB, vesselA, vesselB }) {
  const nameA = vesselA.name || "Vessel A";
  const nameB = vesselB.name || "Vessel B";

  const rows = [
    { section: "Voyage" },
    { label:"Voyage days", a:r=>fmt(r.voyageDays,1)+" d", b:r=>fmt(r.voyageDays,1)+" d", delta:r=>r.voyageDays, lowerBetter:true },
    { label:"Sea days", a:r=>fmt(r.seaDays,1)+" d", b:r=>fmt(r.seaDays,1)+" d", delta:r=>r.seaDays, lowerBetter:true },
    { label:"Cargo lifted", a:r=>fmt(r.cargo)+" t", b:r=>fmt(r.cargo)+" t", delta:r=>r.cargo, higherBetter:true },
    { section: "Revenue & costs" },
    { label:"Gross freight", a:r=>fmtMoneyShort(r.grossFreight), b:r=>fmtMoneyShort(r.grossFreight), delta:r=>r.grossFreight, money:true, higherBetter:true },
    { label:"Bunker cost", a:r=>fmtMoneyShort(r.bunkerCost), b:r=>fmtMoneyShort(r.bunkerCost), delta:r=>r.bunkerCost, money:true, lowerBetter:true },
    { label:"Port + canal", a:r=>fmtMoneyShort(r.portTotal), b:r=>fmtMoneyShort(r.portTotal), delta:r=>r.portTotal, money:true, lowerBetter:true },
    { label:"EU ETS cost", a:r=>fmtMoneyShort(r.etsCostUsd), b:r=>fmtMoneyShort(r.etsCostUsd), delta:r=>r.etsCostUsd, money:true, lowerBetter:true },
    { label:"UK ETS cost", a:r=>fmtMoneyShort(r.ukEtsCostUsd), b:r=>fmtMoneyShort(r.ukEtsCostUsd), delta:r=>r.ukEtsCostUsd, money:true, lowerBetter:true },
    { label:"FuelEU penalty", a:r=>fmtMoneyShort(r.fuelEuPenaltyUsd), b:r=>fmtMoneyShort(r.fuelEuPenaltyUsd), delta:r=>r.fuelEuPenaltyUsd, money:true, lowerBetter:true },
    { label:"Commission", a:r=>fmtMoneyShort(r.commissionUsd), b:r=>fmtMoneyShort(r.commissionUsd), delta:r=>r.commissionUsd, money:true, lowerBetter:true },
    { label:"OPEX (voyage)", a:r=>fmtMoneyShort(r.opexTotal), b:r=>fmtMoneyShort(r.opexTotal), delta:r=>r.opexTotal, money:true, lowerBetter:true },
    { section: "Emissions" },
    { label:"Total CO₂ (TtW)", a:r=>fmt(r.totalCO2_t,0)+" t", b:r=>fmt(r.totalCO2_t,0)+" t", delta:r=>r.totalCO2_t, lowerBetter:true },
    { label:"CO₂eq (CO₂+CH₄+N₂O)", a:r=>fmt(r.totalCO2eq_t,0)+" t", b:r=>fmt(r.totalCO2eq_t,0)+" t", delta:r=>r.totalCO2eq_t, lowerBetter:true },
    { label:"WtW intensity", a:r=>fmt(r.wtwIntensity,1)+" gCO₂e/MJ", b:r=>fmt(r.wtwIntensity,1)+" gCO₂e/MJ", delta:r=>r.wtwIntensity, lowerBetter:true },
    { section: "Bottom line" },
    { label:"Cost per ton delivered", a:r=>fmtMoneyDec(r.costPerTon), b:r=>fmtMoneyDec(r.costPerTon), delta:r=>r.costPerTon, money:true, lowerBetter:true },
    { label:"TCE ($/day) ⭐", a:r=>fmtMoneyShort(r.tce), b:r=>fmtMoneyShort(r.tce), delta:r=>r.tce, money:true, higherBetter:true },
    { label:"Voyage P&L ⭐", a:r=>fmtMoneyShort(r.pnl), b:r=>fmtMoneyShort(r.pnl), delta:r=>r.pnl, money:true, higherBetter:true },
  ];

  return (
    <div className="bcc-compare-table">
      <table>
        <thead>
          <tr>
            <th>Metric</th>
            <th>{nameA}</th>
            <th>{nameB}</th>
            <th>Δ (B − A)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            if (row.section) {
              return <tr key={i} className="bcc-section-row"><td colSpan={4}>{row.section}</td></tr>;
            }
            const dA = row.delta(rA), dB = row.delta(rB);
            const diff = dB - dA;
            let aWin = false, bWin = false;
            if (Math.abs(diff) > 0.01) {
              if (row.higherBetter) { aWin = dA > dB; bWin = dB > dA; }
              if (row.lowerBetter)  { aWin = dA < dB; bWin = dB < dA; }
            }
            let deltaText = row.money
              ? (diff > 0 ? "+" : "") + fmtMoneyShort(diff)
              : (diff > 0 ? "+" : "") + diff.toFixed(Math.abs(diff) < 10 && diff !== 0 ? 2 : 0);
            let deltaClass = "delta-zero";
            if (Math.abs(diff) > 0.01) {
              if (row.higherBetter) deltaClass = diff > 0 ? "delta-pos" : "delta-neg";
              if (row.lowerBetter)  deltaClass = diff < 0 ? "delta-pos" : "delta-neg";
            }
            return (
              <tr key={i}>
                <td className="metric-name">{row.label}</td>
                <td className={aWin ? "winner-cell" : ""}>{row.a(rA)}</td>
                <td className={bWin ? "winner-cell" : ""}>{row.b(rB)}</td>
                <td className={deltaClass}>{deltaText}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function VerdictCard({ rA, rB, vesselA, vesselB, charterType }) {
  const aLabel = VESSEL_DEFAULTS[vesselA.sizeClass].label;
  const bLabel = VESSEL_DEFAULTS[vesselB.sizeClass].label;
  const aName = (vesselA.name || "Vessel A").trim();
  const bName = (vesselB.name || "Vessel B").trim();

  if (!isFinite(rA.tce) || !isFinite(rB.tce)) {
    return (
      <div className="bcc-verdict">
        <div className="bcc-verdict-head">
          <div className="bcc-verdict-icon">★</div>
          <div className="bcc-verdict-title">Recommendation</div>
        </div>
        <p className="bcc-verdict-body">Need valid inputs on both vessels to compare.</p>
      </div>
    );
  }

  const pnlDelta = rA.pnl - rB.pnl;
  const tceDelta = rA.tce - rB.tce;
  const winner = pnlDelta > 0 ? "A" : "B";
  const winnerLabel = winner === "A" ? `${aName} (${aLabel})` : `${bName} (${bLabel})`;
  const loserLabel  = winner === "A" ? `${bName} (${bLabel})` : `${aName} (${aLabel})`;
  const winnerR = winner === "A" ? rA : rB;
  const loserR  = winner === "A" ? rB : rA;
  const absPnlDelta = Math.abs(pnlDelta);
  const absTceDelta = Math.abs(tceDelta);

  const reasons = [];
  const bunkerDelta = winnerR.bunkerCost - loserR.bunkerCost;
  if (Math.abs(bunkerDelta) > 1000)
    reasons.push(bunkerDelta < 0
      ? `Lower bunker bill — ${fmtMoneyShort(Math.abs(bunkerDelta))} less spent on fuel.`
      : `Higher bunker bill, but offset by larger cargo intake.`);

  const cargoDelta = winnerR.cargo - loserR.cargo;
  if (charterType === "voyage" && Math.abs(cargoDelta) > 500)
    reasons.push(cargoDelta > 0
      ? `Bigger stem — carrying ${fmt(Math.abs(cargoDelta))} more tons spreads fixed voyage costs over more revenue.`
      : `Smaller stem than the other vessel, but the cost structure made up for it.`);

  const etsDelta = (winnerR.etsCostUsd + winnerR.ukEtsCostUsd) - (loserR.etsCostUsd + loserR.ukEtsCostUsd);
  if (Math.abs(etsDelta) > 500)
    reasons.push(etsDelta < 0
      ? `Lower carbon-pricing exposure — saved ${fmtMoneyShort(Math.abs(etsDelta))} in EU/UK ETS allowances.`
      : `Higher ETS cost, but compensated elsewhere.`);

  const fuelEuDelta = winnerR.fuelEuPenaltyUsd - loserR.fuelEuPenaltyUsd;
  if (Math.abs(fuelEuDelta) > 500)
    reasons.push(fuelEuDelta < 0
      ? `FuelEU compliant — avoided ${fmtMoneyShort(Math.abs(fuelEuDelta))} in penalties.`
      : `Pays a FuelEU penalty but compensated by other commercial advantages.`);

  const daysDelta = winnerR.voyageDays - loserR.voyageDays;
  if (Math.abs(daysDelta) > 0.3)
    reasons.push(daysDelta < 0
      ? `Faster turnaround — ${Math.abs(daysDelta).toFixed(1)} days shorter voyage.`
      : `Slower turnaround by ${Math.abs(daysDelta).toFixed(1)} days, offset by cargo/cost advantage.`);

  let verdict;
  if (Math.abs(pnlDelta) < 5000) {
    verdict = `It's effectively a tie. ${winnerLabel} edges ahead by ${fmtMoneyShort(absPnlDelta)} per voyage, but the gap is within noise — fuel-price moves of 5–10% will flip the result. TCE delta is ${fmtMoneyShort(absTceDelta)}/day.`;
  } else {
    verdict = `${winnerLabel} is the better choice on this fixture. Voyage P&L is ${fmtMoneyShort(absPnlDelta)} higher and TCE is ${fmtMoneyShort(absTceDelta)}/day stronger than ${loserLabel}. `;
    if (charterType === "voyage") {
      if (winnerR.cargo > loserR.cargo * 1.5) verdict += `The bigger stem dominates here.`;
      else if (winnerR.cargo < loserR.cargo * 0.8) verdict += `The smaller vessel wins because lower bunker burn outweighs the freight uplift.`;
      else verdict += `Both vessels are competitive — the win comes from cost discipline rather than raw size.`;
    } else {
      verdict += `On time-charter terms, the hire-rate spread combined with bunker and compliance burn decides the outcome.`;
    }
  }

  return (
    <div className="bcc-verdict">
      <div className="bcc-verdict-head">
        <div className="bcc-verdict-icon">★</div>
        <div className="bcc-verdict-title">Recommendation</div>
      </div>
      <p className="bcc-verdict-body">{verdict}</p>
      {reasons.length > 0 && (
        <div className="bcc-verdict-notes">
          <ul>{reasons.slice(0, 5).map((r, i) => <li key={i}>{r}</li>)}</ul>
        </div>
      )}
    </div>
  );
}

// ─── Default state ────────────────────────────────────────────────────────────

const defaultVesselA = {
  name: "MV Atlantic Cape", sizeClass: "capesize",
  dwt: 180000, intake: 175000, spdLaden: 14, spdBall: 14.5, focLaden: 42, focBall: 38,
  focAuxSea: 1.8, focAuxPort: 3.5, engine: "ice_2s", fuel: "vlsfo",
  auxEngine: "ice_4s", auxFuel: "lsmgo", pilot: 3, bio: 30, opex: 7500, tcRate: 25000, freightRate: 22,
};
const defaultVesselB = {
  name: "MV Pacific Kamsar", sizeClass: "kamsarmax",
  dwt: 82000, intake: 80000, spdLaden: 14, spdBall: 14.5, focLaden: 30, focBall: 28,
  focAuxSea: 1.5, focAuxPort: 3.0, engine: "ice_2s", fuel: "vlsfo",
  auxEngine: "ice_4s", auxFuel: "lsmgo", pilot: 3, bio: 30, opex: 6700, tcRate: 16000, freightRate: 22,
};

// ─── Main component ───────────────────────────────────────────────────────────

export default function Main() {
  const [howtoOpen, setHowtoOpen] = useState(false);

  // Voyage shared
  const [loadPort, setLoadPort] = useState("Tubarão, Brazil");
  const [dischargePort, setDischargePort] = useState("Qingdao, China");
  const [ladenDist, setLadenDist] = useState(11000);
  const [ballastDist, setBallastDist] = useState(11000);
  const [weatherMargin, setWeatherMargin] = useState(5);
  const [portDaysLoad, setPortDaysLoad] = useState(3);
  const [portDaysDisch, setPortDaysDisch] = useState(3);
  const [canal, setCanal] = useState("none");
  const [cargoType, setCargoType] = useState("iron_ore_fines");
  const [stowage, setStowage] = useState(0.40);
  const [cargoMode, setCargoMode] = useState("max");
  const [cargoQty, setCargoQty] = useState(170000);
  const [charterType, setCharterType] = useState("voyage");
  const [exposure, setExposure] = useState("half");

  // Vessels
  const [vesselA, setVesselA] = useState(defaultVesselA);
  const [vesselB, setVesselB] = useState(defaultVesselB);

  // Market
  const [px, setPx] = useState({
    vlsfo:500, lsmgo:770, hsfo:420, lng:650,
    methanol_fossil:450, methanol_bio:850, methanol_e:1500,
    ammonia_blue:750, ammonia_green:1200, b30:650, biofuel:1100,
  });
  const [portCostLoad, setPortCostLoad] = useState(75000);
  const [portCostDisch, setPortCostDisch] = useState(60000);
  const [canalCost, setCanalCost] = useState(0);
  const [commission, setCommission] = useState(2.5);
  const [calcYear, setCalcYear] = useState("2026");
  const [euaPrice, setEuaPrice] = useState(75);
  const [eurUsd, setEurUsd] = useState(1.08);
  const [fuelEuTarget, setFuelEuTarget] = useState(89.34);
  const [fuelEuPenalty, setFuelEuPenalty] = useState(2400);
  const [repeatYears, setRepeatYears] = useState("0");
  const [bioWtT, setBioWtT] = useState(15);
  const [ukExposure, setUkExposure] = useState("none");
  const [ukaPrice, setUkaPrice] = useState(45);
  const [gbpUsd, setGbpUsd] = useState(1.27);

  function handleCanalChange(val) {
    setCanal(val);
    setCanalCost(CANAL_COSTS[val]);
  }

  function handleCargoTypeChange(val) {
    setCargoType(val);
    setStowage(CARGO_SF[val]);
  }

  function handleYearChange(val) {
    setCalcYear(val);
    const target = FUELEU_TARGETS[parseInt(val)];
    if (target != null) setFuelEuTarget(target);
    else setFuelEuTarget(91.16);
  }

  const shared = { ladenDist, ballastDist, wx: weatherMargin / 100, portDaysLoad, portDaysDisch,
    canal, charterType, exposure, ukExposure, cargoMode, cargoQty, sf: stowage };
  const market = { px, portCostLoad, portCostDisch, canalCost, commissionPct: commission / 100,
    euaPrice, eurUsd, ukaPrice, gbpUsd, fuelEuPenaltyEur: fuelEuPenalty, fuelEuTarget, calcYear, repeatYears, bioWtT };

  const rA = calcVessel(vesselA, shared, market);
  const rB = calcVessel(vesselB, shared, market);
  const winner = rA.pnl >= rB.pnl ? "A" : "B";

  return (
    <div className="bcc-root">
      <style>{BCC_STYLES}</style>

      {/* Header */}
      <header className="bcc-header">
        <div className="bcc-header-inner">
          <div className="bcc-brand">
            <img src="/assets/Zeroqu-Logo.png" alt="Zeroqu" className="bcc-brand-logo" />
            {/* <span className="bcc-brand-sub">Calculators</span> */}
          </div>
          <nav className="bcc-nav">
            <a href="#howto" className="bcc-nav-link">How to use</a>
            <a href="#explainer" className="bcc-nav-link">How it works</a>
          </nav>
        </div>
      </header>

      <main className="bcc-main">
        {/* Hero */}
        <section className="bcc-hero">
          <div className="bcc-eyebrow">Chartering · Dry Bulk</div>
          <h1>Bulk Carrier <em>Chartering</em> Calculator</h1>
          <p>Compare two bulk carriers on the same route and find out which one actually makes more money. Includes <strong>EU ETS phase-in</strong> and <strong>FuelEU Maritime</strong> year-targeted GHG intensity — for ICE, dual-fuel LNG, methanol and ammonia engines.</p>
        </section>

        {/* How to use */}
        <section className="bcc-howto" id="howto">
          <button className="bcc-howto-bar" onClick={() => setHowtoOpen(!howtoOpen)} type="button">
            <span className="bcc-howto-title">
              <span className="bcc-howto-icon">i</span>
              How to use this tool
            </span>
            <span className={`bcc-howto-chev ${howtoOpen ? "open" : ""}`}>▼</span>
          </button>
          {howtoOpen && (
            <div className="bcc-howto-body">
              <p className="bcc-howto-lede">Three steps, side-by-side. Configure your voyage once, drop two candidate vessels into A and B, set the market & compliance assumptions, and read the verdict at the bottom. Everything recalculates live as you type.</p>
              <div className="bcc-howto-grid">
                <HowtoStep step="STEP 1" title="Voyage setup" items={[
                  "Laden & ballast distance in nautical miles. Use sea-distances.org for accurate figures.",
                  "Weather margin: 5% is typical for blue-water routes; 8–10% for North Atlantic winter.",
                  "Canal transit auto-fills indicative Suez/Panama dues.",
                  "Cargo type auto-sets the stowage factor. Iron ore (SF 0.40) is mass-limited; grain (SF 1.30) is volume-limited.",
                  "EU exposure: Non-EU = 0%; EU↔non-EU = 50%; Intra-EU = 100%.",
                ]} />
                <HowtoStep step="STEP 2" title="Configure both vessels" items={[
                  "Size class auto-fills realistic DWT, speeds, FOC and OPEX. Override any field.",
                  "Main FOC laden and ballast in t/d at design speed. Cape range ~38–48; Kamsarmax ~26–32.",
                  "Engine type: ICE 2/4-stroke have no methane slip. DF-LNG options range from 0.2% to 3.1% slip.",
                  "Aux engines run sea + canal + port. Many LNG ships keep aux on MGO for safety.",
                  "Daily OPEX = crew + lubes + repairs + insurance + management.",
                ]} />
                <HowtoStep step="STEP 3" title="Market & compliance" items={[
                  "Bunker prices for every fuel grade. Use today's shipandbunker.com mid.",
                  "EUA price: current EU Allowance price (€/t CO₂eq). Trading roughly €70–90 in 2025–26.",
                  "Calculation year drives both the EU ETS phase-in and the FuelEU target intensity.",
                  "FuelEU target tightens every 5 years. Penalty stays at €2,400/t VLSFOe.",
                  "UK ETS: live from 1 Jul 2026. A voyage is usually under either EU or UK ETS — pick the one that applies.",
                ]} />
                <HowtoStep step="READ" title="Verdict & comparison" items={[
                  "TCE ($/day) is the headline — gross revenue minus voyage costs over voyage days.",
                  "Voyage P&L also deducts OPEX. This is what hits the owner's books.",
                  "★ Winner highlights the better metric in each row of the comparison table.",
                  "Try: keep a Capesize hull, change main engine to DF-LNG LP 4-stroke on Intra-EU — watch the FuelEU penalty appear.",
                ]} />
              </div>
            </div>
          )}
        </section>

        {/* Step 1: Voyage */}
        <StepHeader num="1" title="Voyage setup" desc="Route, cargo, charter mode and EU exposure — shared between Vessel A and Vessel B." />

        <div className="bcc-card">
          <div className="bcc-field-grid">
            <Field label="Load port" hint="(text only)">
              <input className="bcc-input" type="text" value={loadPort} onChange={e => setLoadPort(e.target.value)} />
            </Field>
            <Field label="Discharge port" hint="(text only)">
              <input className="bcc-input" type="text" value={dischargePort} onChange={e => setDischargePort(e.target.value)} />
            </Field>
            <Field label="Laden distance"><NumInput value={ladenDist} onChange={setLadenDist} min={0} step={50} unit="NM" /></Field>
            <Field label="Ballast distance"><NumInput value={ballastDist} onChange={setBallastDist} min={0} step={50} unit="NM" /></Field>
            <Field label="Weather margin"><NumInput value={weatherMargin} onChange={setWeatherMargin} min={0} max={30} step={0.5} unit="%" /></Field>
            <Field label="Port days · load"><NumInput value={portDaysLoad} onChange={setPortDaysLoad} min={0} step={0.5} unit="days" /></Field>
            <Field label="Port days · discharge"><NumInput value={portDaysDisch} onChange={setPortDaysDisch} min={0} step={0.5} unit="days" /></Field>
            <Field label="Canal transit">
              <SelectInput value={canal} onChange={handleCanalChange} options={[
                {value:"none",label:"None"},{value:"suez",label:"Suez Canal"},
                {value:"panama",label:"Panama Canal"},{value:"both",label:"Both (Suez + Panama)"},
              ]} />
            </Field>
          </div>

          <Subgroup title="Cargo">
            <div className="bcc-field-grid">
              <Field label="Cargo type">
                <SelectInput value={cargoType} onChange={handleCargoTypeChange} options={[
                  {value:"iron_ore_fines",label:"Iron ore (fines)"},{value:"iron_ore_lump",label:"Iron ore (lump)"},
                  {value:"coal_steam",label:"Coal (steam)"},{value:"coal_coking",label:"Coal (coking)"},
                  {value:"bauxite",label:"Bauxite"},{value:"grain_wheat",label:"Grain (wheat)"},
                  {value:"grain_corn",label:"Grain (corn)"},{value:"soybean",label:"Soybean"},
                  {value:"petcoke",label:"Petcoke"},{value:"cement",label:"Cement clinker"},
                  {value:"fertilizer",label:"Fertilizer (urea)"},{value:"sugar",label:"Sugar (raw)"},
                  {value:"steel",label:"Steel coils"},{value:"other",label:"Other / custom"},
                ]} />
              </Field>
              <Field label="Stowage factor" hint="(m³/t)">
                <NumInput value={stowage} onChange={setStowage} min={0.30} max={2.50} step={0.05} unit="m³/t" />
              </Field>
              <Field label="Cargo intake mode">
                <SelectInput value={cargoMode} onChange={setCargoMode} options={[
                  {value:"max",label:"Max vessel intake"},{value:"fixed",label:"Fixed quantity"},
                ]} />
              </Field>
              {cargoMode === "fixed" && (
                <Field label="Fixed cargo qty"><NumInput value={cargoQty} onChange={setCargoQty} min={0} step={1000} unit="t" /></Field>
              )}
            </div>
          </Subgroup>

          <Subgroup title="Commercial mode">
            <div className="bcc-row-spread">
              <div>
                <label className="bcc-label" style={{display:"block",marginBottom:"8px"}}>Charter type</label>
                <SegmentedToggle
                  value={charterType}
                  onChange={setCharterType}
                  options={[{value:"voyage",label:"Voyage charter"},{value:"tc",label:"Time charter"}]}
                />
              </div>
              <div>
                <label className="bcc-label" style={{display:"block",marginBottom:"8px"}}>EU exposure</label>
                <SegmentedToggle
                  value={exposure}
                  onChange={setExposure}
                  options={[{value:"none",label:"Non-EU"},{value:"half",label:"EU ↔ non-EU (50%)"},{value:"full",label:"Intra-EU (100%)"}]}
                />
              </div>
            </div>
          </Subgroup>
        </div>

        {/* Step 2: Vessels */}
        <StepHeader num="2" title="Configure both vessels" desc="Name each ship, pick a size class for sensible defaults, then tune the main engine, aux engines and commercials." />

        <div className="bcc-vessels-grid">
          <VesselCard id="A" vessel={vesselA} onChange={setVesselA} charterType={charterType} />
          <VesselCard id="B" vessel={vesselB} onChange={setVesselB} charterType={charterType} />
        </div>

        {/* Step 3: Market */}
        <StepHeader num="3" title="Market & compliance" desc="Bunker prices, port costs, and the EU regulatory year — drives both ETS phase-in and FuelEU target." />

        <div className="bcc-card">
          <Subgroup title="Bunker prices ($/t)">
            <div className="bcc-field-grid">
              {[["vlsfo","VLSFO"],["lsmgo","LSMGO"],["hsfo","HSFO"],["lng","LNG"],
                ["methanol_fossil","Methanol (grey)"],["methanol_bio","Methanol (bio)"],
                ["methanol_e","e-Methanol"],["ammonia_blue","Ammonia (blue)"],
                ["ammonia_green","Ammonia (green)"],["b30","B30 biofuel"],
                ["biofuel","Bio component (UCOME/FAME/HVO)"]
              ].map(([key, label]) => (
                <Field key={key} label={label}>
                  <NumInput value={px[key]} onChange={v => setPx({...px, [key]:v})} min={0} step={5} unit="$/t" />
                </Field>
              ))}
            </div>
          </Subgroup>

          <Subgroup title="Port & canal costs">
            <div className="bcc-field-grid">
              <Field label="Load port cost"><NumInput value={portCostLoad} onChange={setPortCostLoad} min={0} step={1000} unit="USD" /></Field>
              <Field label="Discharge port cost"><NumInput value={portCostDisch} onChange={setPortCostDisch} min={0} step={1000} unit="USD" /></Field>
              <Field label="Canal dues (per transit, auto)"><NumInput value={canalCost} onChange={setCanalCost} min={0} step={1000} unit="USD" /></Field>
              <Field label="Commission"><NumInput value={commission} onChange={setCommission} min={0} max={10} step={0.25} unit="%" /></Field>
            </div>
          </Subgroup>

          <Subgroup title="EU compliance settings">
            <div className="bcc-field-grid">
              <Field label="Calculation year" hint="(drives ETS phase-in + FuelEU target)">
                <SelectInput value={calcYear} onChange={handleYearChange} options={[
                  {value:"2024",label:"2024 · ETS 40% · FuelEU n/a"},
                  {value:"2025",label:"2025 · ETS 70% · FuelEU −2%"},
                  {value:"2026",label:"2026 · ETS 100% · FuelEU −2%"},
                  {value:"2027",label:"2027 · ETS 100% · FuelEU −2%"},
                  {value:"2028",label:"2028 · ETS 100% · FuelEU −2%"},
                  {value:"2029",label:"2029 · ETS 100% · FuelEU −2%"},
                  {value:"2030",label:"2030 · ETS 100% · FuelEU −6%"},
                  {value:"2035",label:"2035 · ETS 100% · FuelEU −14.5%"},
                  {value:"2040",label:"2040 · ETS 100% · FuelEU −31%"},
                  {value:"2045",label:"2045 · ETS 100% · FuelEU −62%"},
                  {value:"2050",label:"2050 · ETS 100% · FuelEU −80%"},
                ]} />
              </Field>
              <Field label="EUA price" hint="(€/t CO₂eq)"><NumInput value={euaPrice} onChange={setEuaPrice} min={0} step={1} unit="€/t" /></Field>
              <Field label="EUR → USD"><NumInput value={eurUsd} onChange={setEurUsd} min={0.5} max={2} step={0.01} unit="$" /></Field>
              <Field label={`FuelEU target (${calcYear}: ${fuelEuTarget})`}>
                <NumInput value={fuelEuTarget} onChange={setFuelEuTarget} min={0} max={100} step={0.01} unit="gCO₂e/MJ" />
              </Field>
              <Field label="FuelEU penalty" hint="(€/t VLSFOe)"><NumInput value={fuelEuPenalty} onChange={setFuelEuPenalty} min={0} step={50} unit="€/t" /></Field>
              <Field label="Repeat non-compliance">
                <SelectInput value={repeatYears} onChange={setRepeatYears} options={[
                  {value:"0",label:"None (1.0×)"},{value:"1",label:"1 prior year (1.1×)"},
                  {value:"2",label:"2 prior years (1.2×)"},{value:"3",label:"3 prior years (1.3×)"},
                  {value:"4",label:"4 prior years (1.4×)"},{value:"5",label:"≥5 prior years (1.5× cap)"},
                ]} />
              </Field>
              <Field label="Biofuel WtT intensity" hint="(for bio share)">
                <NumInput value={bioWtT} onChange={setBioWtT} min={0} max={100} step={0.5} unit="gCO₂e/MJ" />
              </Field>
            </div>
          </Subgroup>

          <Subgroup title="UK ETS (maritime — live from 1 Jul 2026)">
            <div style={{marginBottom:"12px"}}>
              <label className="bcc-label" style={{display:"block",marginBottom:"8px"}}>UK ETS exposure</label>
              <SegmentedToggle value={ukExposure} onChange={setUkExposure} options={[
                {value:"none",label:"None"},{value:"domestic",label:"UK domestic (100%)"},
                {value:"gbni",label:"GB ↔ NI (50%)"},{value:"intl",label:"UK international (50%, 2028+)"},
              ]} />
            </div>
            <div className="bcc-field-grid">
              <Field label="UKA price" hint="(£/t CO₂eq)"><NumInput value={ukaPrice} onChange={setUkaPrice} min={0} step={1} unit="£/t" /></Field>
              <Field label="GBP → USD"><NumInput value={gbpUsd} onChange={setGbpUsd} min={0.5} max={2.5} step={0.01} unit="$" /></Field>
            </div>
            <p className="bcc-note">A voyage is normally subject to either EU or UK ETS, not both — set the one that applies.</p>
          </Subgroup>
        </div>

        {/* Results */}
        <section className="bcc-results">
          <div className="bcc-results-head">
            <h2>Head-to-<em>head</em></h2>
            <span className="bcc-results-tag">Live · auto-updating</span>
          </div>
          <div className="bcc-result-grid">
            <ResultCard id="A" result={rA} isWinner={winner === "A"} vessel={vesselA} market={market} />
            <ResultCard id="B" result={rB} isWinner={winner === "B"} vessel={vesselB} market={market} />
          </div>
        </section>

        {/* Verdict */}
        <VerdictCard rA={rA} rB={rB} vesselA={vesselA} vesselB={vesselB} charterType={charterType} />

        {/* Comparison table */}
        <CompareTable rA={rA} rB={rB} vesselA={vesselA} vesselB={vesselB} />

        {/* Explainer */}
        {/* <section className="bcc-explainer" id="explainer">
          <h2>How the math works</h2>
          <p>The calculator runs an end-to-end voyage P&amp;L for each vessel on the same route, then compares them. The headline metric is <strong>TCE (Time Charter Equivalent)</strong> — what each vessel earns per day after voyage costs, which is the standard metric in dry-bulk chartering because it lets you compare a spot voyage charter directly against a time-charter market rate.</p>

          <h3>1 · Voyage time</h3>
          <pre className="bcc-formula">{`sea_days = (laden_NM × (1+wx) / laden_speed + ballast_NM × (1+wx) / ballast_speed) / 24 voyage_days = sea_days + port_days_load + port_days_disch + canal_days`}</pre>

          <h3>2 · Cargo intake</h3>
          <p>Bulk vessels have two constraints — mass (DWT − bunkers − stores) and volume (cubic capacity of the holds). Whichever bites first sets the stem. We estimate hold volume at <code>~1.25 m³ per DWT</code> (typical for modern bulkers) and pick the smaller of the mass intake and the volumetric limit. So a Capesize on iron ore (SF 0.40) is mass-limited, but the same hull on grain (SF 1.30) is volume-limited and lifts less.</p>
          <pre className="bcc-formula">{`cargo = min(stated_intake, hold_volume / stowage_factor) hold_volume ≈ DWT × 1.25 m³/t`}</pre>

          <h3>3 · Bunker consumption</h3>
          <pre className="bcc-formula">{`fuel_sea  = (focLaden × laden_days) + (focBall × ballast_days) fuel_port = focPort × port_days fuel_total = fuel_sea + fuel_port bunker_cost = fuel_total × fuel_price + pilot_fuel × pilot_price`}</pre>
          <p>For dual-fuel engines, pilot fuel (typically LSMGO, 1–5% of energy) is added separately.</p>

          <h3>4 · CO₂-equivalent (the basis for both ETS schemes)</h3>
          <p>Both EU ETS and UK ETS price the full basket of greenhouse gases on a Tank-to-Wake basis: CO₂ + CH₄ + N₂O, converted to CO₂-equivalent. The calculator applies the GWP100 values mandated for the MRV/ETS regime (IPCC AR5, per Reg (EU) 2020/1044): CH₄ = 28, N₂O = 265.</p>
          <pre className="bcc-formula">{`CO2eq (t) = CO₂ + CH₄ × 28 + N₂O × 265 CH₄ = combustion CH₄ + methane slip (LNG engines) N₂O = combustion N₂O (all fuels; significant for ammonia)`}</pre>
          <p>This matters in two non-obvious ways. First, an LNG engine&apos;s methane slip (1.7–3.1% on LP-Otto engines) dominates its CO₂eq even though LNG&apos;s pure CO₂ is lower than VLSFO. Second, N₂O adds ~1.5% for conventional fuels — but for &quot;zero-carbon&quot; green ammonia, N₂O slip is the only emission and still produces real CO₂eq the schemes will charge for.</p>

          <h3>5 · EU ETS (2024–2026 phase-in)</h3>
          <p>The maritime EU ETS phases in: 40% of emissions in 2024, 70% in 2025, 100% from 2026. CO₂ only in 2024–25; CH₄ and N₂O join from 2026. Scope: 100% for intra-EU/EEA voyages, 50% for voyages between an EU/EEA and a non-EU port. Priced in EUA (€).</p>
          <pre className="bcc-formula">{`ets_cost (€) = CO2eq_basis (t) × EUA_price × scope × phase_in basis: CO₂ only (2024–25), CO₂eq (2026+) scope: intra-EU = 1.0, EU↔non-EU = 0.5, non-EU = 0.0 phase_in: 0.40 (2024), 0.70 (2025), 1.00 (2026+)`}</pre>

          <h3>6 · UK ETS (maritime — live 1 July 2026)</h3>
          <p>The UK extended its ETS to domestic maritime from 1 July 2026, covering CO₂ + CH₄ + N₂O from launch for vessels ≥5,000 GT. Priced in a separate allowance (UKA, £). Phase 1 (2026–27): UK-domestic at 100%, GB↔NI at 50%. Phase 2 (proposed 2028): international voyages at 50%, aligning with EU ETS scope.</p>
          <pre className="bcc-formula">{`uk_ets_cost (£) = CO2eq (t) × UKA_price × uk_scope uk_scope: domestic = 1.0, GB↔NI = 0.5, intl = 0.5 (from 2028)`}</pre>
          <p>A given voyage is normally subject to either EU ETS or UK ETS, not both — set the regime that applies to your route.</p>

          <h3>7 · FuelEU Maritime (Well-to-Wake)</h3>
          <p>FuelEU prices the well-to-wake GHG intensity of fuel energy used on board, in gCO₂eq/MJ. The 2025–2029 target is 89.34 gCO₂eq/MJ (a 2% cut from the 2020 fleet baseline of 91.16), tightening every 5 years to 18.23 by 2050. FuelEU uses its own GWPs (AR4: CH₄ = 25, N₂O = 298), already embedded in the WtW intensity factors. Over-target triggers a penalty of €2,400 per tonne of VLSFO-equivalent deficit, with a 1.0–1.5× multiplier for consecutive non-compliance.</p>
          <pre className="bcc-formula">{`CB (gCO2eq) = (target − actual_intensity) × total_energy_MJ penalty (€) = |CB| / (target × 41,000) × 2,400 × repeat_mult scope: intra-EU = 1.0, EU↔non-EU = 0.5`}</pre>
          <p>If the vessel&apos;s actual intensity is below target, no penalty (and a surplus can be banked or pooled in real operation — not modelled here).</p>

          <h3>8 · TCE and P&amp;L</h3>
          <pre className="bcc-formula">{`gross_freight = cargo × freight_rate  (voyage charter) gross_revenue = TC_rate × voyage_days  (time charter) voyage_costs = bunker + port + canal + EU_ETS + UK_ETS + FuelEU + commission TCE  = (gross_freight − voyage_costs) / voyage_days P&L  = (gross_freight − voyage_costs − OPEX × voyage_days)`}</pre>

          <h3>Engine emission factors</h3>
          <p>The methane slip number is the key differentiator between ICE and dual-fuel LNG. For a Capesize on a 22,000-NM round voyage at full EU exposure, a 3.1% slip (LP 4-stroke) can add tens of thousands of dollars in EU ETS cost versus an ICE 2-stroke on VLSFO — even though LNG&apos;s pure CO₂ TtW intensity is lower than VLSFO.</p>
          <ul style={{margin:"12px 0 16px", paddingLeft:"20px", display:"flex", flexDirection:"column", gap:"6px", color:"var(--ink-soft)", fontSize:"0.92rem", lineHeight:"1.55"}}>
            <li><strong>ICE 2-stroke / 4-stroke:</strong> 0% methane slip. WtW intensity for VLSFO ≈ 91.5 gCO₂e/MJ, for LSMGO ≈ 93.3 gCO₂e/MJ.</li>
            <li><strong>DF-LNG HP 2-stroke</strong> (Diesel cycle, MAN ME-GI): ~0.2% slip. WtW ≈ 76 gCO₂e/MJ.</li>
            <li><strong>DF-LNG LP 2-stroke</strong> (Otto, WinGD X-DF): ~1.7% slip. WtW ≈ 86 gCO₂e/MJ.</li>
            <li><strong>DF-LNG LP 4-stroke</strong> (Otto, Wärtsilä DF): ~3.1% slip. WtW ≈ 98 gCO₂e/MJ — often above the 2026 FuelEU target.</li>
            <li><strong>Methanol</strong> (grey/bio/e-): WtW varies from 105 (grey) down to 7 (e-methanol RFNBO).</li>
            <li><strong>Ammonia</strong> (blue/green): WtW 45 (blue) / 5 (green). N₂O slip not yet captured in default factors.</li>
          </ul>

          <p className="bcc-ref">Regulatory references · IMO MEPC.364(79) (TtW carbon factors) · EU ETS Directive 2003/87/EC as amended by 2023/959 · UK ETS (maritime extension, domestic from 1 Jul 2026; UK ETS Authority Response 2025) · FuelEU Maritime Regulation (EU) 2023/1805 · GWP100 values per Reg (EU) 2020/1044 (AR5) for ETS and RED II (AR4) for FuelEU · GHG WtW factors per FuelEU Annex II. Calculations are estimates for screening; final compliance figures depend on monitoring plan, verified MRV data, and fuel certifications.</p>
        </section> */}

        <section className="bcc-explainer" id="explainer">
          <h2>Disclaimer</h2>
          <p>This Bulk Carrier Chartering Calculator is provided by Zeroqu for informational and indicative purposes only. All calculations, estimates, and outputs generated by this tool are based on user-provided inputs and simplified assumptions, and do not constitute professional maritime, commercial, legal, or financial advice.
          Zeroqu makes no representations or warranties, express or implied, regarding the accuracy, completeness, or fitness for any particular purpose of the results produced by this calculator. Users are solely responsible for verifying all outputs independently before making any chartering, commercial, or operational decisions.
          Zeroqu, its directors, employees, and affiliates shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in connection with the use of, or reliance upon, any information or calculation provided by this tool.
          <pre><strong>By using this calculator, you acknowledge and agree that your use is entirely at your own risk.</strong></pre></p>
        </section>

      </main>

      {/* CTA Banner */}
      <div className="bcc-cta-banner">
        <div className="bcc-cta-inner">
          <div className="bcc-cta-text">
            <div className="bcc-cta-eyebrow">From estimate to fleet</div>
            <h2 className="bcc-cta-heading">Want this <em>across</em> your whole fleet?</h2>
            <p className="bcc-cta-body">Zeroqu turns noon reports, MRV data, and stem fixtures into automated TCE, EU ETS and FuelEU calculations for every vessel, every voyage, every day.</p>
          </div>
          <a href="https://www.zeroqu.com/our-story#write-to-us" className="bcc-cta-btn" target="_blank" rel="noopener noreferrer">
            <span className="bcc-cta-btn-logo">Book a Demo</span>
            {/* <span className="bcc-cta-btn-arrow">→</span> */}
          </a>
        </div>
      </div>

      <footer className="bcc-footer">
        Built by Zeroqu · Reference values are typical estimates and not advisory. Verify with your operator for fixture decisions.
      </footer>
    </div>
  );
}

function StepHeader({ num, title, desc }) {
  return (
    <div className="bcc-step-header">
      <div className="bcc-step-num">{num}</div>
      <div>
        <h2>{title}</h2>
        <p>{desc}</p>
      </div>
    </div>
  );
}

function HowtoStep({ step, title, items }) {
  return (
    <div className="bcc-howto-step">
      <h4><span className="bcc-pill">{step}</span> {title}</h4>
      <ul>{items.map((item, i) => <li key={i}>{item}</li>)}</ul>
    </div>
  );
}

// ─── Styles ───────────────────────────────────────────────────────────────────

const BCC_STYLES = `
  /* ============================================================
     CSS custom properties — mirrors HTML reference exactly
     All font-family → StevieSans, sans-serif per brand requirement
     ============================================================ */

  .bcc-root {
    --castleton:    #275A46;
    --castleton-2:  #1d4435;
    --olivine:      #A4C681;
    --olivine-2:    #b8d398;
    --olivine-tint: #e6efd4;
    --ucla:         #4D7298;
    --ink:          #17312a;
    --ink-soft:     #3a4f47;
    --ink-mute:     #6b7f76;
    --paper:        #f7f9f5;
    --paper-2:      #ecf1e6;
    --white:        #ffffff;
    --vessel-a:     #275A46;
    --vessel-a-bg:  #dfe9e1;
    --vessel-b:     #4D7298;
    --vessel-b-bg:  #dde7f1;
    --good:         #2d7a3e;
    --bad:          #b54148;
    --line:         rgba(23,49,42,0.09);
    --line-mid:     rgba(23,49,42,0.17);
    --shadow-sm:    0 1px 2px rgba(23,49,42,0.05), 0 1px 3px rgba(23,49,42,0.04);
    --font: 'StevieSans', sans-serif;
    --r1: 4px; --r2: 8px; --r3: 12px; --r4: 16px;
    --r5: 24px; --r6: 32px; --r7: 48px; --r8: 64px;

    font-family: 'StevieSans', sans-serif;
    font-size: 22px;
    line-height: 1.55;
    color: var(--ink);
    background: var(--paper);
    background-image:
      radial-gradient(ellipse at top right, rgba(164,198,129,0.12), transparent 50%),
      radial-gradient(ellipse at bottom left, rgba(39,90,70,0.05), transparent 50%);
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
  }
  .bcc-root *, .bcc-root *::before, .bcc-root *::after { box-sizing: border-box; font-family: 'StevieSans', sans-serif; }
  .bcc-root h1, .bcc-root h2, .bcc-root h3, .bcc-root h4 {
    font-family: 'StevieSans', sans-serif;
    font-weight: 700; letter-spacing: -0.02em; line-height: 1.15; margin: 0;
  }
  .bcc-root h1 { font-size: clamp(2rem, 4vw + 0.4rem, 3.2rem); font-weight: 800; letter-spacing: -0.03em; }
  .bcc-root h1 em {
    font-style: normal; color: var(--castleton); font-weight: 800;
    position: relative; display: inline;
    background: linear-gradient(transparent 85%, rgba(164,198,129,0.65) 85%);
  }
  .bcc-root h1 em::after { content: none; }
  .bcc-root h2 { font-size: clamp(1.6rem, 2vw + 0.5rem, 2.1rem); font-weight: 700; }
  .bcc-root h3 { font-size: 1.45rem; font-weight: 700; }
  .bcc-root p { margin: 0 0 12px; }
  .bcc-root a { color: var(--castleton); text-decoration: none; transition: color .15s; }
  .bcc-root a:hover { color: var(--castleton-2); }

  /* Header */
  .bcc-header {
    border-bottom: 1px solid var(--line);
    background: rgba(247,249,245,0.88);
    backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
    position: sticky; top: 0; z-index: 100;
  }
  .bcc-header-inner {
    display: flex; align-items: center; justify-content: space-between;
    padding: 16px 24px; max-width: 100%; margin: 0 auto;
  }
  .bcc-brand { display: flex; align-items: center; gap: 12px; }
  .bcc-brand-logo { height: 30px; width: auto; display: block; object-fit: contain; }
  .bcc-brand-sub {
    font-family: 'StevieSans', sans-serif; font-size: 0.82rem; font-weight: 700;
    letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-mute);
    padding-left: 12px; margin-left: 8px; border-left: 1px solid var(--line-mid);
  }
  .bcc-nav { display: flex; gap: 4px; }
  .bcc-nav-link {
    color: var(--ink-soft); font-size: 0.9rem; font-weight: 500;
    padding: 8px 14px; border-radius: 6px; transition: background 0.15s;
  }
  .bcc-nav-link:hover { background: var(--paper-2); color: var(--ink); }
  @media (max-width: 640px) { .bcc-brand-sub { display: none; } }

  /* Layout */
  .bcc-main { max-width: 100%; margin: 0 auto; padding: 0 0 80px; }

  /* Hero */
  .bcc-hero { padding: var(--r7) 24px var(--r6); }
  .bcc-eyebrow {
    font-family: 'StevieSans', sans-serif; font-size: 0.7rem; font-weight: 700;
    letter-spacing: 0.2em; text-transform: uppercase; color: var(--castleton); margin-bottom: 12px;
  }
  .bcc-hero h1 { margin-bottom: 14px; max-width: 22ch; }
  .bcc-hero p { font-size: 1.05rem; color: var(--ink-soft); max-width: 64ch; line-height: 1.55; }

  /* How-to */
  .bcc-howto {
    background: linear-gradient(135deg, rgba(164,198,129,0.18), rgba(208,220,220,0.25));
    border: 1px solid var(--line); border-radius: 16px; margin: 0 24px 24px; overflow: hidden;
  }
  .bcc-howto-bar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 16px 24px; cursor: pointer; gap: 12px; background: transparent;
    width: 100%; text-align: left; font-family: inherit; border: none; font-size: inherit;
  }
  .bcc-howto-bar:hover { background: rgba(255,255,255,0.45); }
  .bcc-howto-title {
    display: flex; align-items: center; gap: 12px;
    font-family: 'StevieSans', sans-serif; font-weight: 500; font-size: 1.1rem; color: var(--castleton-2);
  }
  .bcc-howto-icon {
    width: 32px; height: 32px; background: var(--castleton); color: var(--paper);
    border-radius: 8px; display: grid; place-items: center; font-weight: 600; font-family: 'StevieSans', sans-serif;
  }
  .bcc-howto-chev { color: var(--castleton-2); transition: transform 0.2s; }
  .bcc-howto-chev.open { transform: rotate(180deg); }
  .bcc-howto-body { padding: 0 24px 24px; }
  .bcc-howto-lede { color: var(--ink-soft); margin-bottom: 16px; max-width: 80ch; line-height: 1.6; }
  .bcc-howto-grid { display: grid; grid-template-columns: 1fr; gap: 16px; }
  @media (min-width: 780px) { .bcc-howto-grid { grid-template-columns: 1fr 1fr; } }
  .bcc-howto-step {
    background: rgba(255,255,255,0.7); border-radius: 10px; padding: 16px; border: 1px solid var(--line);
  }
  .bcc-howto-step h4 { color: var(--castleton-2); margin-bottom: 10px; display: flex; align-items: center; gap: 8px; }
  .bcc-pill {
    background: var(--castleton); color: var(--paper);
    font-family: 'StevieSans', sans-serif; font-size: 0.7rem; font-weight: 600;
    padding: 3px 8px; border-radius: 999px; letter-spacing: 0.04em;
  }
  .bcc-howto-step ul { list-style: none; padding: 0; display: flex; flex-direction: column; gap: 7px; }
  .bcc-howto-step li { font-size: 1rem; color: var(--ink-soft); line-height: 1.5; padding-left: 16px; position: relative; }
  .bcc-howto-step li::before { content: '→'; position: absolute; left: 0; top: 0; color: var(--olivine); font-weight: 700; }

  /* Step header */
  .bcc-step-header { display: flex; align-items: center; gap: 14px; margin: var(--r7) 0 var(--r6); padding: 0 24px; }
  .bcc-step-header:first-of-type { margin-top: var(--r6); }
  .bcc-step-num {
    display: grid; place-items: center; width: 38px; height: 38px;
    background: var(--castleton); color: var(--paper); border-radius: 10px;
    font-family: 'StevieSans', sans-serif; font-weight: 600; font-size: 1.05rem; flex-shrink: 0;
  }
  .bcc-step-header h2 { margin-bottom: 2px; line-height: 1.15; }
  .bcc-step-header p { color: var(--ink-mute); font-size: 1.05rem; line-height: 1.4; margin: 0; }

  /* Card */
  .bcc-card {
    background: var(--white); border: 1px solid var(--line); border-radius: 18px;
    padding: 24px; box-shadow: var(--shadow-sm); margin: 0 24px 24px;
    width: calc(100% - 48px); box-sizing: border-box;
  }
  @media (min-width: 720px) { .bcc-card { padding: 32px; } }

  /* Field system */
  .bcc-field-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px 16px; }
  .bcc-field { display: flex; flex-direction: column; gap: 6px; }
  .bcc-label { font-size: 0.92rem; font-weight: 500; color: var(--ink-soft); letter-spacing: 0.02em; }
  .bcc-hint { color: var(--ink-mute); font-weight: 400; font-size: 0.84rem; }
  .bcc-input-wrap { position: relative; }
  .bcc-input {
    width: 100%; padding: 10px 12px; border: 1px solid var(--line-mid); border-radius: 8px;
    background: var(--white); font-family: 'StevieSans', sans-serif; font-size: 1.05rem; color: var(--ink);
  }
  .bcc-input:focus { outline: none; border-color: var(--castleton); box-shadow: 0 0 0 3px var(--olivine-tint); }
  .bcc-input[type="number"]::-webkit-inner-spin-button, .bcc-input[type="number"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
  .bcc-unit {
    position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
    color: var(--ink-mute); font-family: 'StevieSans', sans-serif; font-size: 0.9rem; pointer-events: none;
  }
  .bcc-input-wrap .bcc-input { padding-right: 48px; }
  .bcc-select {
    width: 100%; padding: 10px 32px 10px 12px; border: 1px solid var(--line-mid); border-radius: 8px;
    background: var(--white) url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3e%3cpath d='M3 4.5l3 3 3-3' stroke='%236b8794' stroke-width='1.5' fill='none' stroke-linecap='round'/%3e%3c/svg%3e") no-repeat right 12px center;
    font-family: 'StevieSans', sans-serif; font-size: 1.05rem; color: var(--ink);
    appearance: none; -webkit-appearance: none;
  }
  .bcc-select:focus { outline: none; border-color: var(--castleton); box-shadow: 0 0 0 3px var(--olivine-tint); }

  /* Segmented */
  .bcc-segmented { display: inline-flex; background: var(--paper-2); border-radius: 10px; padding: 3px; gap: 2px; flex-wrap: wrap; }
  .bcc-segmented button {
    padding: 7px 14px; border-radius: 7px; font-size: 1rem; font-weight: 500;
    color: var(--ink-soft); transition: all 0.15s; font-family: 'StevieSans', sans-serif; border: none; background: none; cursor: pointer;
  }
  .bcc-segmented button.active { background: var(--white); color: var(--ink); box-shadow: var(--shadow-sm); }
  .bcc-segmented button:hover:not(.active) { color: var(--ink); }

  /* Subgroup */
  .bcc-subgroup { padding-top: 16px; margin-top: 16px; border-top: 1px dashed var(--line); }
  .bcc-subgroup-title { font-size: 0.84rem; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--ink-mute); margin-bottom: 12px; }
  .bcc-note { font-size: 1rem; color: var(--ink-mute); margin-top: 8px; margin-bottom: 0; line-height: 1.5; }
  .bcc-row-spread { display: flex; justify-content: flex-start; align-items: flex-start; gap: 28px; flex-wrap: wrap; }

  /* Vessels grid */
  .bcc-vessels-grid { display: grid; grid-template-columns: 1fr; gap: 24px; margin: 0 24px 24px; width: calc(100% - 48px); }
  @media (min-width: 1080px) { .bcc-vessels-grid { grid-template-columns: 1fr 1fr; } }

  /* Vessel card */
  .bcc-vessel-card {
    background: var(--white); border: 1px solid var(--line); border-radius: 18px;
    padding: 0 24px 24px; box-shadow: var(--shadow-sm); overflow: hidden; width: 100%; box-sizing: border-box;
  }
  @media (min-width: 720px) { .bcc-vessel-card { padding: 0 32px 28px; } }
  .bcc-vessel-banner {
    margin: 0 -24px 20px; padding: 14px 24px;
    display: flex; align-items: center; justify-content: space-between;
    border-bottom: 1px solid var(--line);
  }
  @media (min-width: 720px) { .bcc-vessel-banner { margin: 0 -32px 20px; padding: 14px 32px; } }
  .banner-a { background: var(--vessel-a-bg); }
  .banner-b { background: var(--vessel-b-bg); }
  .bcc-vessel-chip { display: inline-flex; align-items: center; gap: 8px; font-family: 'StevieSans', sans-serif; font-weight: 500; font-size: 1.1rem; }
  .bcc-dot { width: 12px; height: 12px; border-radius: 50%; }
  .dot-a { background: var(--vessel-a); }
  .dot-b { background: var(--vessel-b); }
  .bcc-vessel-hint { font-size: 0.78rem; color: var(--ink-mute); font-family: 'StevieSans', sans-serif; }

  /* Results section */
  .bcc-results {
    background: var(--castleton); color: var(--paper);
    border-radius: 20px; padding: 32px; margin: var(--r7) 24px 24px; position: relative; overflow: hidden;
  }
  .bcc-results::before {
    content: ''; position: absolute; right: -120px; top: -120px; width: 380px; height: 380px;
    background: radial-gradient(circle, rgba(164,198,129,0.20), transparent 60%); pointer-events: none;
  }
  .bcc-results::after {
    content: ''; position: absolute; left: -80px; bottom: -80px; width: 280px; height: 280px;
    background: radial-gradient(circle, rgba(164,198,129,0.10), transparent 60%); pointer-events: none;
  }
  .bcc-results-head { display: flex; align-items: baseline; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 24px; position: relative; z-index: 1; padding: 0; }
  .bcc-results-head h2 { color: var(--paper); }
  .bcc-results-head h2 em { color: var(--olivine); font-style: normal; }
  .bcc-results-tag { font-family: 'StevieSans', sans-serif; font-size: 0.78rem; color: var(--olivine-tint); letter-spacing: 0.05em; }
  .bcc-result-grid { display: grid; grid-template-columns: 1fr; gap: 24px; position: relative; z-index: 1; padding: 0; }
  @media (min-width: 880px) { .bcc-result-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 640px) { .bcc-results { margin: var(--r7) 12px 24px; padding: 24px 16px; border-radius: 16px; } }

  /* Result vessel */
  .bcc-result-vessel {
    background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 16px; padding: 24px;
  }
  .result-a { border-left: 3px solid var(--olivine); }
  .result-b { border-left: 3px solid var(--olivine-2); }
  .result-winner { background: rgba(164,198,129,0.10); border-color: rgba(164,198,129,0.30); box-shadow: 0 0 0 1px rgba(164,198,129,0.30); }
  .bcc-result-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; flex-wrap: wrap; gap: 8px; }
  .bcc-result-title { font-family: 'StevieSans', sans-serif; font-size: 1.1rem; font-weight: 500; color: var(--paper); }
  .bcc-result-title small { display: block; font-family: 'StevieSans', sans-serif; font-size: 0.72rem; font-weight: 500; color: var(--olivine-tint); text-transform: uppercase; letter-spacing: 0.08em; margin-top: 2px; }
  .bcc-winner-badge {
    display: inline-flex; align-items: center; gap: 5px;
    background: var(--olivine); color: var(--ink);
    padding: 4px 10px; border-radius: 999px; font-size: 0.7rem; font-weight: 600;
    letter-spacing: 0.08em; text-transform: uppercase;
  }

  /* Headline number */
  .bcc-headline-num { margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid rgba(255,255,255,0.10); }
  .bcc-hn-label { font-size: 0.82rem; font-weight: 600; letter-spacing: 0.16em; text-transform: uppercase; color: var(--olivine-tint); margin-bottom: 6px; }
  .bcc-hn-value { font-family: 'StevieSans', sans-serif; font-size: clamp(2.2rem, 5vw, 3.2rem); font-weight: 400; letter-spacing: -0.02em; color: var(--paper); line-height: 1; }
  .bcc-hn-value.neg { color: #f4b896; }
  .bcc-hn-unit { font-family: 'StevieSans', sans-serif; font-size: 1rem; font-weight: 500; color: var(--olivine-tint); margin-left: 6px; }

  /* Stat rows */
  .bcc-stat-group { margin-bottom: 16px; }
  .bcc-stat-group-title { font-size: 0.82rem; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--olivine-2); margin-bottom: 8px; }
  .bcc-stat-rows { display: flex; flex-direction: column; gap: 8px; }
  .bcc-stat-row { display: flex; justify-content: space-between; align-items: baseline; padding: 6px 0; font-size: 1rem; border-bottom: 1px dashed rgba(255,255,255,0.08); }
  .bcc-stat-row:last-child { border-bottom: none; }
  .bcc-stat-label { color: rgba(245,241,232,0.65); }
  .bcc-stat-value { font-family: 'StevieSans', sans-serif; color: var(--paper); font-weight: 500; font-size: 1rem; }
  .bcc-stat-value.bad { color: #ffb59a; }
  .bcc-stat-value.good { color: #8ad99e; }

  /* Verdict */
  .bcc-verdict {
    background: var(--white); border: 2px solid var(--olivine); border-radius: 18px;
    padding: 32px; margin: 0 24px 48px; position: relative;
  }
  .bcc-verdict::before {
    content: ''; position: absolute; top: -1px; left: -1px; right: -1px; height: 60px;
    background: linear-gradient(180deg, rgba(164,198,129,0.12), transparent);
    border-radius: 16px 16px 0 0; pointer-events: none;
  }
  .bcc-verdict-head { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; position: relative; }
  .bcc-verdict-icon {
    width: 38px; height: 38px; border-radius: 10px; background: var(--olivine);
    display: grid; place-items: center; color: var(--castleton);
    font-family: 'StevieSans', sans-serif; font-weight: 700; font-size: 1.3rem; flex-shrink: 0;
  }
  .bcc-verdict-title { font-family: 'StevieSans', sans-serif; font-size: 1.3rem; font-weight: 700; color: var(--ink); }
  .bcc-verdict-body { font-size: 1.1rem; color: var(--ink-soft); line-height: 1.7; margin-bottom: 0; position: relative; }
  .bcc-verdict-notes { margin-top: 16px; padding-top: 16px; border-top: 1px solid var(--line); }
  .bcc-verdict-notes ul { list-style: none; padding: 0; display: flex; flex-direction: column; gap: 8px; }
  .bcc-verdict-notes li { padding-left: 22px; position: relative; font-size: 1.05rem; color: var(--ink-soft); line-height: 1.5; }
  .bcc-verdict-notes li::before { content: '◆'; position: absolute; left: 0; top: 6px; color: var(--olivine); font-size: 0.7rem; }

  /* Compare table */
  .bcc-compare-table { background: var(--white); border: 1px solid var(--line); border-radius: 16px; overflow: hidden; margin: 0 24px 24px; overflow-x: auto; }
  .bcc-compare-table table { width: 100%; border-collapse: collapse; font-size: 1.05rem; }
  .bcc-compare-table thead th { text-align: left; padding: 14px 16px; background: var(--paper-2); font-weight: 600; font-size: 0.86rem; letter-spacing: 0.12em; text-transform: uppercase; color: var(--ink-mute); border-bottom: 1px solid var(--line); }
  .bcc-compare-table thead th:nth-child(2), .bcc-compare-table thead th:nth-child(3), .bcc-compare-table thead th:nth-child(4) { text-align: right; font-family: 'StevieSans', sans-serif; }
  .bcc-compare-table tbody td { padding: 12px 16px; border-bottom: 1px solid var(--line); }
  .bcc-compare-table tbody tr:last-child td { border-bottom: none; }
  .bcc-section-row td { background: var(--paper); font-family: 'StevieSans', sans-serif; font-size: 0.92rem; font-weight: 500; color: var(--castleton-2); letter-spacing: 0.02em; padding-top: 14px; padding-bottom: 10px; }
  .bcc-compare-table tbody td:nth-child(2), .bcc-compare-table tbody td:nth-child(3) { text-align: right; font-family: 'StevieSans', sans-serif; font-size: 1.02rem; color: var(--ink); }
  .bcc-compare-table tbody td:nth-child(4) { text-align: right; font-family: 'StevieSans', sans-serif; font-size: 0.98rem; font-weight: 500; }
  .metric-name { color: var(--ink-soft); font-weight: 500; }
  .winner-cell { background: linear-gradient(90deg, transparent, rgba(164,198,129,0.10)); position: relative; }
  .winner-cell::before { content: '★'; color: var(--olivine); margin-right: 6px; font-size: 0.85em; }
  .delta-pos { color: var(--good); }
  .delta-neg { color: var(--bad); }
  .delta-zero { color: var(--ink-mute); }

  /* Explainer */
  .bcc-explainer { margin-top: var(--r8); padding: var(--r6) 24px 0; border-top: 1px solid var(--line); margin-bottom: 0; }
  .bcc-explainer h2 { margin-bottom: 16px; }
  .bcc-explainer h3 { margin-top: 24px; margin-bottom: 12px; }
  .bcc-explainer p { color: var(--ink-soft); line-height: 1.65; margin-bottom: 12px; }
  .bcc-formula {
    background: var(--paper-2); border-left: 3px solid var(--castleton); padding: 12px 16px;
    border-radius: 0 8px 8px 0; font-family: 'StevieSans', sans-serif; font-size: 1rem;
    color: var(--ink); margin: 12px 0; overflow-x: auto; white-space: pre;
  }
  .bcc-ref { font-size: 0.96rem; color: var(--ink-mute); background: var(--olivine-tint); padding: 12px 16px; border-radius: 8px; margin-top: 12px; line-height: 1.55; }

  /* CTA Banner */
  .bcc-cta-banner {
    margin: var(--r5) 24px 0;
    background: var(--castleton);
    border-radius: 20px;
    overflow: hidden;
  }
  @media (max-width: 640px) {
    .bcc-cta-banner { margin: var(--r8) 12px 0; border-radius: 16px; }
  }
  .bcc-cta-inner {
    padding: 48px 48px;
    display: flex; align-items: center; justify-content: space-between; gap: 40px;
    flex-wrap: wrap;
  }
  .bcc-cta-text { flex: 1; min-width: 260px; }
  .bcc-cta-eyebrow {
    font-family: var(--font); font-size: 0.7rem; font-weight: 700;
    letter-spacing: 0.18em; text-transform: uppercase;
    color: var(--olivine); margin-bottom: 12px;
  }
  .bcc-cta-heading {
    font-family: var(--font); font-size: clamp(1.8rem, 3.5vw, 2.6rem);
    font-weight: 800; color: var(--paper); margin-bottom: 14px; letter-spacing: -0.02em;
  }
  .bcc-cta-heading em { font-style: normal; color: var(--olivine); }
  .bcc-cta-body { font-size: 1.15rem; color: rgba(247,249,245,0.78); line-height: 1.65; max-width: 56ch; margin: 0; }
  .bcc-cta-btn {
    display: inline-flex; align-items: center; gap: 10px;
    background: #ffffff; color: var(--castleton);
    border-radius: 999px; padding: 16px 32px;
    font-family: var(--font); font-weight: 700; font-size: 1.15rem;
    letter-spacing: 0.01em; text-decoration: none; white-space: nowrap;
    transition: background 0.15s, transform 0.15s, box-shadow 0.15s; flex-shrink: 0;
    box-shadow: 0 2px 12px rgba(0,0,0,0.18);
  }
  .bcc-cta-btn:hover { background: var(--paper); transform: translateY(-1px); color: var(--castleton); box-shadow: 0 4px 18px rgba(0,0,0,0.22); }
  .bcc-cta-btn-logo span { color: var(--olivine); }
  .bcc-cta-btn-arrow { font-size: 1.5rem; }
  @media (max-width: 640px) {
    .bcc-cta-inner { flex-direction: column; align-items: flex-start; padding: 36px 24px; gap: 28px; }
  }

  /* Footer */
  .bcc-footer { margin-top: var(--r8); border-top: 1px solid var(--line); text-align: center; padding: 32px 24px; font-size: 1rem; color: var(--ink-mute); }
`;